import React from 'react';
import { useController } from 'react-hook-form';
import { MdPictureAsPdf } from 'react-icons/md';

const SelectableCard = ({ name, control, options, rules }) => {
  const {
    field: { value = [], onChange, onBlur, ref },
    fieldState: { error, isTouched }
  } = useController({
    name,
    control,
    rules,
    defaultValue: []
  });

  const handleCheckboxChange = (checkboxValue) => (event) => {
    let newValue = Array.isArray(value) ? [...value] : [];
    if (event.target.checked) {
      newValue.push(checkboxValue);
    } else {
      newValue = newValue.filter((v) => v !== checkboxValue);
    }
    onChange(newValue);
    onBlur();
  };

  return (
    <>
      {options.map(({ label, value: optionValue }, index) => {
        const checked = value.includes(optionValue);
        
        return (
          <div key={`checkbox-${index}`}>
            <input 
              type="checkbox" 
              id={`checkbox-${index}`} 
              name={`${name}[${index}]`} 
              value={optionValue} 
              checked={checked} 
              onChange={handleCheckboxChange(optionValue)}
              ref={ref}
              className="hidden-card-checkbox" 
            />
            <label className="card card--selectable" htmlFor={`checkbox-${index}`}>
              <MdPictureAsPdf />
            </label>
            <label className="card-sublabel" htmlFor={`checkbox-${index}`}>
              {label}
            </label>
          </div>
        );
      })}
      {isTouched && error && <p className="error">{error.message}</p>}
    </>
  );
};

export default SelectableCard;
